import "./Css/app.css";
import "./Css/snack.css";
import "./Css/menu.css";

import { NumberInput, TextInput, Button, Select, ModalWindow, Root, MultilineInput, DestroyingPatternContentSwitcher, HashRef } from "@tblabs/truffle";
import { DatabaseViewPage } from "./Pages/DatabaseViewPage";
import { UserEditPage } from "./Pages/UserEditPage";
import { AddUserPage } from "./Pages/AddUserPage";
import { UserViewPage } from "./Pages/UserViewPage";
import { DatasetViewPage } from "./Pages/DatasetViewPage";
import { Router } from "./Services/Router";
import { IStorageUser, OnlineStorage } from "@tblabs/storage";
import { LoginPage } from "./Pages/LoginPage";
import { LoginFormLogic } from "./Services/Auth/LoginLogic";
import { PageHeader } from "./Components/PageHeader";
import { AllDatabasesPage } from "./Pages/AllDatabasesPage";
import { AddDatabasePage } from "./Pages/AddDatabasePage";
import { AddDatasetPage } from "./Pages/AddDatasetPage";
import { DatasetItemEditPage } from "./Pages/DatasetItemEditPage";
import { AddItemPage } from "./Pages/AddItemPage";
import { AppState } from "./Services/AppState";
import { DatasetItemViewPage } from "./Pages/DatasetItemViewPage";
import { DataseMetadataEditPage } from "./Pages/DataseMetadataEditPage";

NumberInput.DefaultCssClasses = "uk-input uk-form-width-small";
TextInput.DefaultCssClasses = "uk-input";
Button.DefaultCssClasses = "uk-button uk-button-default";
Select.DefaultCssClasses = "uk-select";
ModalWindow.DefaultCssClasses = "tf-modal-window";
ModalWindow.Hook = Root.Hook;
MultilineInput.DefaultCssClasses = "uk-textarea";


(async () =>
{
    const root = new Root().Class("root");
    const hash = new HashRef();

    const _router = new Router(hash);
    const _storage = new OnlineStorage("", "");
    const _appState = new AppState();
    const _loginLogic = new LoginFormLogic(_storage)
        .OnLogin((user: IStorageUser, autologin: boolean) =>
        {
            if (_storage.DatabaseDir === "admin")
                _appState.SetSubtitle("All databases @ " + _storage.Server);
            else
                _appState.SetSubtitle(_storage.DatabaseDir + " @ " + _storage.Server);

            if (_storage.DatabaseDir === "admin")
                _router.GoToAllDatabasesPage();
            else
                if (!autologin)
                    _router.GoToDatabasePage(_storage.DatabaseDir);
        })
        .OnLogout(() =>
        {
            _appState.SetSubtitle("");
            _loginLogic.ClearLoginInfo();
            _router.GoToLoginPage();
        })

    root.Append(new PageHeader(_storage, _router, _appState));

    await _loginLogic.TryAutoLogin();

    const content = new DestroyingPatternContentSwitcher(hash)
        .AddContent("login/:database/:user", ({ database, user }) => new LoginPage(_loginLogic, _storage, database, user))
        .AddContent("login/:database/:user/:password", ({ database, user, password }) => new LoginPage(_loginLogic, _storage, database, user, password))
        .AddContent("login", () => new LoginPage(_loginLogic, _storage))
        .AddContent("admin/databases/add", () => new AddDatabasePage(_storage))
        .AddContent("admin/databases", () => new AllDatabasesPage(_storage))
        .AddContent("admin/database/:db", ({db}) => new DatabaseViewPage(_storage, _appState, db))
        .AddContent("admin/dataset/:datasetName/metadata/edit", ({ datasetName }) => new DataseMetadataEditPage(_storage, datasetName))
        .AddContent("admin/dataset/add", () => new AddDatasetPage(_storage))
        .AddContent("admin/dataset/:datasetName/view", ({ datasetName }) => new DatasetViewPage(_storage, datasetName))
        .AddContent("admin/dataset/:datasetName/add", ({ datasetName }) => new AddItemPage(_storage, datasetName))
        .AddContent("admin/dataset/:datasetName/:itemId/view", ({ datasetName, itemId }) => new DatasetItemViewPage(_storage, datasetName, itemId))
        .AddContent("admin/dataset/:datasetName/:itemId/edit", ({ datasetName, itemId }) => new DatasetItemEditPage(_storage, datasetName, itemId))
        .AddContent("admin/user/add", () => new AddUserPage(_storage))
        .AddContent("admin/user/:userId/edit", ({ userId }) => new UserEditPage(_storage, userId))
        .AddContent("admin/user/:userId", ({ userId }) => new UserViewPage(_storage, userId))
        .AddDefaultContent(() => new DatabaseViewPage(_storage, _appState))
        .Refresh()

    root.Append(content);
})()
